import React, { useState } from "react";

import { FormButton } from "components";
import { FormikSelectInput, FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    rowSelected,
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import { FORM_ERROR_MESSAGES } from "consts/errorMessages";

import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { connectionUpd } from "services/services-mia";

const estados = [
    { estadoCod: "P", estadoNombre: "Pendiente" },
    { estadoCod: "A", estadoNombre: "Activo" },
    { estadoCod: "B", estadoNombre: "Baja" },
    { estadoCod: "S", estadoNombre: "Suspendido" },
    { estadoCod: "X", estadoNombre: "Cancelado" },
    { estadoCod: "R", estadoNombre: "Rechazado" },
];

const estadosTransiciones = {
    P: ["P", "X"],
    A: ["A", "B", "S"],
    B: ["B"],
    S: ["S", "A"],
    X: ["X", "P"],
    R: ["R", "B"],
};

const emailRegex =
    /^(([^<>()[\]\\.,;:#\s@"]+(\.[^<>()[\]\\.,;:#\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default function UpdateModal({ updateList, roles, user, closeModal }) {
    const setSelected = useSetRecoilState(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    const [inRequest, setInRequest] = useState(false);

    const handleSubmit = async ({
        rol,
        estado,
        email
    }) => {
        setInRequest(true);

        const response = await connectionUpd(
            user.id,
            estado,
            email,
            rol,
            credentials
        );

        const functions = {
            setSnackbarInfo,
            setInRequest,
            setIsOpen: closeModal,
            setSelected,
            updateList,
        };

        handleResponse(
            response,
            "Conexión modificada exitosamente",
            functions
        );
    };

    const estadosFiltrados = user.estadoCod
        ? estados.filter((e) =>
            estadosTransiciones[user.estadoCod].includes(e.estadoCod)
        )
        : [];

    return (
        <Formik
            initialValues={{
                estado: user.estadoCod,
                email: user.email ?? "",
                rol: user.rolCod,
            }}
            validationSchema={
                yup.object({
                    rol: yup.string(FORM_ERROR_MESSAGES.text)
                        .required(FORM_ERROR_MESSAGES.required)
                        .oneOf(roles.map((rol) => rol.rolCod)),
                    estado: yup.string(FORM_ERROR_MESSAGES.text)
                        .required(FORM_ERROR_MESSAGES.required)
                        .oneOf(estadosFiltrados.map((estado) => estado.estadoCod)),
                    email: yup.string(FORM_ERROR_MESSAGES.text)
                        .matches(emailRegex, { message: "Email inválido" })
                        .nullable(),
                })
            }
            onSubmit={(values, { setSubmitting }) => {
                try {
                    handleSubmit(values);
                } catch (e) {
                    setSnackbarInfo({
                        message: e.errmsg,
                        severity: "error",
                        open: true,
                    });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column-sm"]}>
                    <FormikSelectInput
                        fullWidth={true}
                        name="rol"
                        labelText={"Rol"}
                    >
                        {roles.map(({ rolCod, rolNombre }) => (
                            <option
                                key={rolCod}
                                data-id={rolCod}
                                value={rolCod}
                            >
                                {rolNombre}
                            </option>
                        ))}
                    </FormikSelectInput>

                    <FormikSelectInput
                        fullWidth={true}
                        name="estado"
                        labelText={"Estado"}
                    >
                        {estadosFiltrados.map(({ estadoCod, estadoNombre }) => (
                            <option
                                key={estadoCod}
                                data-id={estadoCod}
                                value={estadoCod}
                            >
                                {estadoNombre}
                            </option>
                        ))}
                    </FormikSelectInput>

                    <FormikTextInput
                        fullWidth={true}
                        name="email"
                        labelText={"Mail"}
                    />

                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Guardar cambios" }}
                        onCloseModal={closeModal}
                    />
                </div>
            </Form>
        </Formik>
    );
}
